import { ApiClient } from "@/services/apiClient";
import { UserBankInfo_Schema } from "@/services/user/bankInfo/bankInfoSchema";
import type { UpdateOrCreateBankInfoData, UserBankInfo, UserBankInfoId } from "@/services/user/bankInfo/bankInfoTypes";
import type { AxiosResponse } from "axios";

type ApiResponse_FetchList = {
  paymentInfoList: UserBankInfo[];
};

export async function fetchUserBankInfo(): Promise<UserBankInfo | undefined> {
  const url = `api/address/payment-info`;
  return ApiClient.get<ApiResponse_FetchList>(url).then(({ data }) => {
    // API returns a list, we want only one
    const list = data.paymentInfoList;
    if (list.length === 0) {
      return undefined;
    } else {
      const bankInfoResponse = list.pop();
      return UserBankInfo_Schema.parse(bankInfoResponse);
    }
  });
}

export async function deleteUserBankInfo(id: UserBankInfoId): Promise<AxiosResponse> {
  const url = `api/address/payment-info/${id}`;
  return ApiClient.delete(url);
}

export async function createUserBankInfo(data: UpdateOrCreateBankInfoData): Promise<UserBankInfo> {
  const url = `api/address/payment-info`;
  return ApiClient.post(url, {}, data).then((response) => UserBankInfo_Schema.parse(response.data));
}

export async function updateUserBankInfo(id: UserBankInfoId, data: UpdateOrCreateBankInfoData): Promise<UserBankInfo> {
  const url = `api/address/payment-info/${id}`;
  return ApiClient.put(url, {}, data).then((response) => UserBankInfo_Schema.parse(response.data));
}
